/* CHN Mystery Deal — flip-to-win + Klaviyo claim gate
 * Client-side only. Public Klaviyo key + list id come from data attributes.
 * Flow: pick card -> weighted-random prize assigned -> gate -> Klaviyo -> reveal code. */
(function () {
  'use strict';

  var KLAVIYO_REVISION = '2024-10-15';

  function pickWeighted(prizes) {
    var total = 0, i;
    for (i = 0; i < prizes.length; i++) total += Math.max(1, prizes[i].weight || 1);
    var r = Math.random() * total;
    for (i = 0; i < prizes.length; i++) {
      r -= Math.max(1, prizes[i].weight || 1);
      if (r <= 0) return prizes[i];
    }
    return prizes[prizes.length - 1];
  }

  function toE164(raw) {
    var d = (raw || '').replace(/[^0-9]/g, '');
    if (!d) return '';
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    if (raw.charAt(0) === '+') return raw.replace(/[^0-9+]/g, '');
    return '+' + d;
  }

  function kFetch(path, key, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body)
    });
  }

  function subscribe(key, listId, email, phone, props) {
    var profileAttrs = {
      email: email,
      properties: props,
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    };
    if (phone) {
      profileAttrs.phone_number = phone;
      profileAttrs.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Mystery Deal Landing',
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        }
      }
    };
    if (listId) {
      body.data.relationships = { list: { data: { type: 'list', id: listId } } };
    }
    return kFetch('subscriptions', key, body);
  }

  function upsertProfile(key, email, phone, props) {
    var attrs = { email: email, properties: props };
    if (phone) attrs.phone_number = phone;
    return kFetch('profiles', key, { data: { type: 'profile', attributes: attrs } });
  }

  function trackEvent(key, email, phone, props) {
    var profileAttrs = { email: email };
    if (phone) profileAttrs.phone_number = phone;
    return kFetch('events', key, {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: 'Claimed Mystery Deal' } } },
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        }
      }
    });
  }

  function fireMetaLead(props) {
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', { content_name: 'Mystery Deal', content_category: props.chn_goal });
      }
    } catch (e) {}
  }

  function collectionPath(url) {
    if (!url) return '/';
    try { return new URL(url, window.location.origin).pathname + (new URL(url, window.location.origin).search || ''); }
    catch (e) { return url; }
  }

  function initRoot(root) {
    var key = root.getAttribute('data-klaviyo-key');
    var listId = root.getAttribute('data-klaviyo-list');
    var niche = root.getAttribute('data-niche') || 'general';
    var collectionUrl = root.getAttribute('data-collection-url') || '/collections/all';
    var successUrl = root.getAttribute('data-success-url') || '';

    var prizesEl = root.querySelector('[data-cfw-prizes]');
    var prizes = [];
    try { prizes = JSON.parse(prizesEl.textContent) || []; } catch (e) { prizes = []; }
    if (!prizes.length) prizes = [{ label: '10% OFF', sub: 'your first order', code: 'MYSTERY10', weight: 1 }];

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cfw-card]'));
    var hint = root.querySelector('[data-cfw-hint]');
    var gate = root.querySelector('[data-cfw-gate]');
    var form = root.querySelector('[data-cfw-form]');
    var errorEl = root.querySelector('[data-cfw-error]');
    var submitBtn = root.querySelector('[data-cfw-submit]');
    var result = root.querySelector('[data-cfw-result]');
    var codeEl = root.querySelector('[data-cfw-code]');
    var ctaEl = root.querySelector('[data-cfw-cta]');

    var chosen = null;
    var locked = false;

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (locked) return;
        locked = true;
        chosen = pickWeighted(prizes);

        card.querySelector('[data-cfw-prize-label]').textContent = chosen.label || '';
        card.querySelector('[data-cfw-prize-sub]').textContent = chosen.sub || '';
        card.classList.add('is-flipped');
        cards.forEach(function (c) { if (c !== card) c.classList.add('is-dim'); });
        if (hint) hint.style.display = 'none';

        setTimeout(function () {
          gate.classList.add('is-open');
          gate.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.style.display = 'none';

      var email = (form.email.value || '').trim();
      var phone = toE164(form.phone.value);
      var consent = form.consent.checked;

      if (!email || email.indexOf('@') === -1) { showError('Please enter a valid email.'); return; }
      if (!phone || phone.length < 11) { showError('Please enter a valid mobile number.'); return; }
      if (!consent) { showError('Please agree to receive messages to claim your deal.'); return; }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Unlocking…';

      var props = {
        chn_goal: niche,
        prize_won: chosen.label,
        mystery_code: chosen.code,
        source_page: window.location.pathname
      };

      var calls = [];
      if (key) {
        calls.push(subscribe(key, listId, email, phone, props).catch(function () {}));
        calls.push(upsertProfile(key, email, phone, props).catch(function () {}));
        calls.push(trackEvent(key, email, phone, props).catch(function () {}));
      }

      Promise.all(calls).then(function () {
        fireMetaLead(props);
        reveal(chosen, collectionUrl, successUrl, codeEl, ctaEl, gate, result);
      }).catch(function () {
        // Even if Klaviyo hiccups, still give them the code — don't lose the sale.
        fireMetaLead(props);
        reveal(chosen, collectionUrl, successUrl, codeEl, ctaEl, gate, result);
      });
    });

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtn.getAttribute('data-label') || 'UNLOCK MY DEAL';
    }
  }

  function reveal(chosen, collectionUrl, successUrl, codeEl, ctaEl, gate, result) {
    if (successUrl) { window.location.href = successUrl; return; }
    codeEl.textContent = chosen.code || '';
    // Auto-apply discount then land on the goal collection.
    var path = collectionPath(collectionUrl);
    if (chosen.code) {
      ctaEl.setAttribute('href', '/discount/' + encodeURIComponent(chosen.code) + '?redirect=' + encodeURIComponent(path));
    } else {
      ctaEl.setAttribute('href', path);
    }
    gate.classList.remove('is-open');
    result.classList.add('is-open');
    result.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-cfw]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
